import { useEffect, useMemo, useState } from "react";
import * as yup from "yup";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FerramentasDeDetalhe } from "../../shered/components";
import { VForm, useVForm, IVFormErrors } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    Box, Button, Icon,
     Paper, Tooltip, Typography, useTheme,    
    Autocomplete,
    CircularProgress,
    TextField,
    Tabs,
    Tab
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import { FranquiaService, IDetalheFranquia } from "../../shered/services/api/franquia/FranquiaService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { DialogMensagem, IDadosModal, IModalProps } from "../../shered/components/modal/DialogMensagem";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { TDropOptions, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { Loading } from "../../shered/components/loading/Loading";
import { DataGrid, GridActionsCellItem, GridColDef } from "@mui/x-data-grid";
import { IDadosStats, DraftService,  IDadosPreferenciaJogadorDraftEscolha, IDadosPreferenciaJogadorDraft } from "../../shered/services/api/draft/DraftService";


//dados do insert de franquia
interface IFormData {
    nome: string;
    capital: number;
    codEstado: number;
}

export interface IDadosImagemFranquia {
    imageFile: File | null;
    Imagem: string;
    SrcImagem: string | ArrayBuffer | null | undefined;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ? 
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
                // value === index && (
                 <Box sx={{ p: UtilidadeService.isMobile() ? 1 : 3 }}>
                    <Grid>{children}</Grid>
                </Box>
                //)
            }
        </div>
         : ""}
        </>
    );
}

export const DetalheDeDraftEscolhas: React.FC = () => {
    const { themeName } = useAppThemeContext();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [codigoFranquia, setCodigoFranquia] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const { logout } = useAuthContext();
    const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [codigoTemporada, setCodigoTemporada] = useState(1);
    const [opcoesAutoCompleteJogadorInicial, setOpcoesAutoCompleteJogadorInicial] = useState<TDropOptions[]>([])
    const [opcoesAutoCompleteJogadorCalouros, setOpcoesAutoCompleteJogadorCalouros] = useState<TDropOptions[]>([])
    const [nome_Franquia, setNome_Franquia] = useState("");
    const [tempo_Escolha_Calouro, setTempo_Escolha_Calouro] = useState(0);
    const user = CookieService.get("access_user");
    const theme = useTheme();
    const { id } = useParams<"id">();
    const [franquia, setFranquia] = useState<IDetalheFranquia>();
    const [searchParams, SetSearchParams] = useSearchParams();
    const [nomeLiga, setNomeLiga] = useState("");
    const navigate = useNavigate();
    const { formRef, save, saveAndClose } = useVForm();
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [showImagemLiga, setShowImagemLiga] = useState<any>("../../semimagemescudo.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [escolhaAtual, setEscolhaAtual] = useState(1);
    const [showDraftCalouros, setShowDraftCalouros] = useState(false);
    const [showDraftInicial, setShowDraftInicial] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [showModalMensagem, setShowModalMensagem] = useState(false);   
    const [removeLoading, setRemoveLoading] = useState(false);
    const [existeDadosJogadorCalouro, setExisteDadosJogadorCalouro] = useState(false);
    const [existeDadosJogadorInicial, setExisteDadosJogadorInicial] = useState(false);
    const [fotoJogador, setFotoJogador] = useState<string>("");
    const [nomeJogador, setNomeJogador] = useState<string>("");
    const [franquiaJogador, setFranquiaJogador] = useState<string>("");
    const [salario1, setSalario1] = useState<string>("");
    const [salario2, setSalario2] = useState<string>("");
    const [salario3, setSalario3] = useState<string>("");
    const [salario4, setSalario4] = useState<string>("");
    const [salario5, setSalario5] = useState<string>("");
    const [listaDataGridCalouro, setListaDataGridCalouro] = useState<IDadosPreferenciaJogadorDraftEscolha[]>([]);
    const [listaDataGridInicial, setListaDataGridInicial] = useState<IDadosPreferenciaJogadorDraftEscolha[]>([]);
    const [listaStats, setListaStats] = useState<IDadosStats[]>([]);
    const [value, setValue] = useState(0);
    const [atualizarCalouro, setAtualizarCalouro] = useState(false);
    const [atualizarInicial, setAtualizarInicial] = useState(false);

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "0");
    }, [searchParams]);

    const [salario1Calouro, setSalario1Calouro] = useState<string>("");
    const [salario2Calouro, setSalario2Calouro] = useState<string>("");
    const [salario3Calouro, setSalario3Calouro] = useState<string>("");
    const [salario4Calouro, setSalario4Calouro] = useState<string>("");
    const [salario5Calouro, setSalario5Calouro] = useState<string>("");
    const [selectedIdCompleteInicial, setSelectedIdCompleteInicial] = useState<number | undefined>(0);
    const [selectedIdCompleteCalouros, setSelectedIdCompleteCalouros] = useState<number | undefined>(0);

    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options);
    const autoCompleteSelectedOptionInicial = useMemo(() => {
        if (!selectedIdCompleteInicial) return null;

        const selectedOption = opcoesAutoCompleteJogadorInicial.find(opcao => opcao.codigo === selectedIdCompleteInicial);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdCompleteInicial, opcoesAutoCompleteJogadorInicial]);

    const autoCompleteSelectedOptionCalouros = useMemo(() => {
        if (!selectedIdCompleteCalouros) return null;

        const selectedOption = opcoesAutoCompleteJogadorCalouros.find(opcao => opcao.codigo === selectedIdCompleteCalouros);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdCompleteCalouros, opcoesAutoCompleteJogadorCalouros]);

    useEffect(() => {
        const fetchData = async () => {
            setShowModalMensagem(false);
            if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
                setIsLoading(false);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "warning",
                    mensagem: "Favor selecionar uma liga!",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            }
            setExisteDadosJogadorCalouro(false);
            setExisteDadosJogadorInicial(false);
            setIsLoading(true);
            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    setDadosLiga(liga);
                    setNomeLiga(liga.nome);
                    setShowImagemLiga(liga.logo);
                    setTempo_Escolha_Calouro(liga.tempo_Escolha_Calouro);
                    setCodigoTemporada(liga.codigo_Temporada);
                    CarregarDadosFranquia(liga.abertura_Draft === true ? liga.abertura_Draft : liga.sem_Relogio_Calouro, liga.abertura_Draft_Inicial === true ? liga.abertura_Draft_Inicial : liga.sem_Relogio_Inicial);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });

            FranquiaService.getByIdLigaIdUsuario(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    let franquia = result.dado;
                    formRef.current?.setData(franquia);
                    setFranquia(franquia);
                    setShowImagemFranquia(franquia.caminho_Logo === null ? "../../semimagemescudo.png" : franquia.caminho_Logo);
                    setNome_Franquia(franquia.nome);
                    setRemoveLoading(true);
                    setCodigoTemporada(franquia.codigo_Temporada !== undefined ? franquia.codigo_Temporada : 1);

                    //CarregarTabelaDraftJogadoresCalouro(Number(codigoLiga), franquia.codigo_Temporada, franquia.codigo);
                    //CarregarTabelaDraftJogadoresInicial(Number(codigoLiga), franquia.codigo_Temporada, franquia.codigo);
                }).catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão Expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response.data.mensagem !== undefined) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });
        }
        fetchData();
    }, [codigoLiga]);

    const handleSave = async () => {
        setIsLoading(true);


        if (listaDataGridCalouro.length > 0 && atualizarCalouro) {
            let lstDadosCalouro: IDadosPreferenciaJogadorDraft[] = [];

            const lstAuxCalouro: any = listaDataGridCalouro.length > 0
                ? listaDataGridCalouro.map(o => ({
                    codigo_Liga: o.codigo_Liga,
                    codigo_Temporada: o.codigo_Temporada,
                    codigo_Franquia: o.codigo_Franquia,
                    codigo_Jogador: o.codigo_Jogador,
                    ordem: o.ordem,
                    calouro: true,
                    codUsuCriacao: user.codUsuario
                })) : [];

            DraftService.CreatePreferenciaDraft(lstAuxCalouro)
                .then((result) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Dados cadastrados com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }

        if (listaDataGridInicial.length > 0 && atualizarInicial) {
            let lstDadosInicial: IDadosPreferenciaJogadorDraft[] = [];

            const lstAuxInicial: any = listaDataGridInicial.length > 0
                ? listaDataGridInicial.map(o => ({
                    codigo_Liga: o.codigo_Liga,
                    codigo_Temporada: o.codigo_Temporada,
                    codigo_Franquia: o.codigo_Franquia,
                    codigo_Jogador: o.codigo_Jogador,
                    ordem: o.ordem,
                    calouro: false,
                    codUsuCriacao: user.codUsuario
                })) : [];

            DraftService.CreatePreferenciaDraft(lstAuxInicial)
                .then((result) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Dados cadastrados com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }

    }

    const columnsEscolhas: GridColDef[] = [
        {
            field: 'ordem',
            headerName: 'ORDEM',
            flex: 1,
            width: UtilidadeService.isMobile() ? 50 : 90,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center'
        },
        {
            field: 'codigo_Jogador',
            headerName: 'CÓDIGO',
            width: 90,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'foto_Jogador',
            headerName: 'FOTO',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            minWidth: UtilidadeService.isMobile() ? 50 : 130,
            renderCell: (params) => <img src={(params.value !== null && params.value !== "" && params.value !== undefined) ? params.value : semImagem} alt={params.value} width={UtilidadeService.isMobile() ? 30 : 45} height={UtilidadeService.isMobile() ? 30 : 50} />
        },
        {
            field: 'nome_Jogador',
            headerName: 'JOGADOR',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            minWidth: UtilidadeService.isMobile() ? 130 : 200,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'actions',
            headerName: 'AÇÃO',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            flex: 1,
            sortable: false,
            minWidth: UtilidadeService.isMobile() ? 65 : 130,

            getActions: (params) => [
                <GridActionsCellItem
                    icon={<Tooltip title="Excluir"><Icon>cancel</Icon></Tooltip>}
                    label="Excluir"
                    onClick={() => value === 0 ? handleExcluirEscolhaCalouro(params.row.codigo_Jogador) : handleExcluirEscolhaInicial(params.row.codigo_Jogador)}
                //disabled={!user.administrador && user.codUsuario !== codigoUsuario}

                />
            ]
        }
    ];

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);

    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
    }

    const CarregarDadosFranquia = async (draftCalourosAberta: boolean, draftInicialAberta: boolean) => {        
        await FranquiaService.getByIdLigaIdUsuario(Number(codigoLiga))
            .then((result) => {
                setIsLoading(false);
                let franquia = result.dado;
                formRef.current?.setData(franquia);
                setFranquia(franquia);
                setCodigoFranquia(franquia.codigo);
                if (draftCalourosAberta || draftInicialAberta) {
                    setShowDraftCalouros(draftCalourosAberta);
                    setShowDraftInicial(draftInicialAberta);
                    CarregarDropListaJogadoresInicial(Number(codigoLiga), Number(franquia.codigo_Temporada));
                    CarregarTabelaDraftJogadoresInicial(Number(codigoLiga), Number(franquia.codigo_Temporada), Number(franquia.codigo));
                    CarregarDropListaJogadoresCalouros(Number(codigoLiga), Number(franquia.codigo_Temporada));
                    CarregarTabelaDraftJogadoresCalouros(Number(codigoLiga), Number(franquia.codigo_Temporada), Number(franquia.codigo));
                }

            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão Expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    if (errors.response.data.mensagem !== undefined) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
    }

    const CarregarDropListaJogadoresInicial = async (codLiga: number, codTemporada: number) => {
        await JogadorService.getBuscarTodoDraftInicialResumidoTemporada(codLiga, codTemporada)
            .then((result) => {
                setIsLoading(false);
                let lstAux = result.dado.sort((a, b) => a.nome > b.nome ? 1 : -1);
                //setListaJogadoresInicial(lstAux);
                const lstDrop: TDropOptions[] = lstAux.map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
                setOpcoesAutoCompleteJogadorInicial(lstDrop);
            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");

                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });
    }

    const CarregarDropListaJogadoresCalouros = async (codLiga: number, codTemporada: number) => {
        await JogadorService.getBuscarTodoDraftTemporada(codLiga, codTemporada)
            .then((result) => {
                setIsLoading(false);
                const lstDrop: TDropOptions[] = result.data.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
                    .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
                setOpcoesAutoCompleteJogadorCalouros(lstDrop);
            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");

                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });
    }

    const CarregarTabelaDraftJogadoresInicial = async (codLiga: number, codTemporada: number, codigoFranquia: number) => {

        await DraftService.getDraftPreferencialInicial(codLiga, codTemporada, codigoFranquia)
            .then((result) => {
                setShowModalMensagem(false);
                setIsLoading(false);
                let resultado = result.dado;
                setListaDataGridInicial(resultado);
                setRemoveLoading(true);

            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados do Draft. Favor tentar mais tarde e caso o problema persista, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const CarregarTabelaDraftJogadoresCalouros = async (codLiga: number, codTemporada: number, codigoFranquia: number) => {
        await DraftService.getDraftPreferencialCalouro(codLiga, codTemporada, codigoFranquia)
            .then((result) => {
                setShowModalMensagem(false);
                setIsLoading(false);
                let resultado = result.dado;
                setListaDataGridCalouro(resultado);
                setRemoveLoading(true);
            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados dos jogadores! Favor tentar novamente.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const handleCarregarDadosJogadorInicial = async (codigoJogador: any) => {
        setRemoveLoading(false);
        setIsLoading(true);
        let dados: any = {};
        if (codigoJogador === undefined) {
            setIsLoading(false);
            setRemoveLoading(true);
            return;
        }

        DraftService.getDadosJogadorSelecionadoInicial(codigoJogador, Number(franquia?.codigo), Number(escolhaAtual))
            .then((result) => {

                const dados = result.dado;
                setFotoJogador(dados.foto_Jogador);
                setNomeJogador(dados.nome_Jogador);
                setFranquiaJogador(dados.nome_Franquia);
                setSalario1(dados.salario1);
                setSalario2(dados.salario2);
                setSalario3(dados.salario3);
                setSalario4(dados.salario4);
                setSalario5(dados.salario5);
                setExisteDadosJogadorInicial(true);
                var lstStats = dados.stats_Liga.reduce((unique: IDadosStats[], o) => {
                    if (!unique.some(obj => obj.nome === o.nome)) {
                        unique.push(o);
                    }
                    return unique;
                }, []);

                setListaStats(lstStats);
                setIsLoading(false);
                setRemoveLoading(true);
            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });
    }

    const handleCarregarDadosJogadorCalouro = async (codigo: any) => {
        setRemoveLoading(false);
        setIsLoading(true);
        if (codigo === undefined) {
            return;
        }
        await DraftService.getDadosJogadorSelecionadoCalouro(codigo, Number(franquia?.codigo))
            .then((result) => {

                const dados = result.dado;
                setFotoJogador(dados.foto_Jogador);
                setNomeJogador(dados.nome_Jogador);
                setFranquiaJogador(dados.nome_Franquia);
                setSalario1Calouro(dados.salario1);
                setSalario2Calouro(dados.salario2);
                setSalario3Calouro(dados.salario3);
                setSalario4Calouro(dados.salario4);
                setSalario5Calouro(dados.salario5);
                setExisteDadosJogadorCalouro(true);
                var lstStats = dados.stats_Liga.reduce((unique: IDadosStats[], o) => {
                    if (!unique.some(obj => obj.nome === o.nome)) {
                        unique.push(o);
                    }
                    return unique;
                }, []);

                setListaStats(lstStats);
                setRemoveLoading(true);
                setIsLoading(false);
            }).catch((errors) => {
                setIsLoading(false);

                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });
    }

    const handleAdicionarJogadorCalouro = () => {
        setAtualizarCalouro(true);
        if (typeof selectedIdCompleteCalouros !== null && typeof selectedIdCompleteCalouros !== undefined) {
            if (listaDataGridCalouro.find(f => f.codigo_Jogador === Number(selectedIdCompleteCalouros))) {
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "warning",
                    mensagem: "Jogador já incluído!",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            }
        }

        setListaDataGridCalouro([...listaDataGridCalouro,
        {
            ordem: listaDataGridCalouro.length + 1,
            foto_Jogador: fotoJogador,
            codigo_Jogador: Number(selectedIdCompleteCalouros),
            nome_Jogador: nomeJogador,
            codigo_Franquia: codigoFranquia,
            codigo_Liga: Number(codigoLiga),
            codigo_Temporada: codigoTemporada,
            calouro: true
        }]);

        setSelectedIdCompleteCalouros(0);
        setListaStats([]);
    }

    const handleExcluirEscolhaCalouro = (row: number) => {
        setAtualizarCalouro(true);
        if (window.confirm("Realmente deseja apagar?")) {
            let newList = listaDataGridCalouro.filter((i) => i.codigo_Jogador != row)
            setListaDataGridCalouro(moveObject(newList));
        }
    }

    const moveObject = (arr: IDadosPreferenciaJogadorDraftEscolha[]) => {

        const result = arr.map((m, i) => ({
            ordem: i + 1,
            codigo_Jogador: m.codigo_Jogador,
            foto_Jogador: m.foto_Jogador,
            nome_Jogador: m.nome_Jogador,
            codigo_Liga: m.codigo_Liga,
            codigo_Temporada: m.codigo_Temporada,
            codigo_Franquia: m.codigo_Franquia,
            calouro: true

        }));

        return result;
    }

    const handleAdicionarJogadorInicial = () => {
        setAtualizarInicial(true);
        if (typeof selectedIdCompleteInicial !== null && typeof selectedIdCompleteInicial !== undefined) {
            if (listaDataGridInicial.find(f => f.codigo_Jogador === Number(selectedIdCompleteInicial))) {
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "warning",
                    mensagem: "Jogador já incluído!",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            }
        }

        setListaDataGridInicial([...listaDataGridInicial,
        {
            ordem: listaDataGridInicial.length + 1,
            foto_Jogador: fotoJogador,
            codigo_Jogador: Number(selectedIdCompleteInicial),
            nome_Jogador: nomeJogador,
            codigo_Franquia: codigoFranquia,
            codigo_Liga: Number(codigoLiga),
            codigo_Temporada: codigoTemporada,
            calouro: false
        }]);

        setSelectedIdCompleteInicial(0);
        setListaStats([]);
    }

    const handleExcluirEscolhaInicial = (row: number) => {
        setAtualizarInicial(true);
        if (window.confirm("Realmente deseja apagar?")) {
            let newList = listaDataGridInicial.filter((i) => i.codigo_Jogador != row)
            setListaDataGridInicial(moveObject(newList));
        }
    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setExisteDadosJogadorCalouro(false);
        setExisteDadosJogadorInicial(false);
        setValue(newValue);
    };


    return (
        <LayoutBaseDePagina
            titulo={"Draft Preferêncial - " + nomeLiga}
            showLogoImg={showImagemLiga}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={true}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid alignItems="center" justifyContent="center" width="100%">
                            <Paper>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={value} variant="scrollable"
                                        scrollButtons onChange={handleChangeTabs}>
                                        <Tab label="Escolhas Calouros" {...a11yProps(0)} />
                                        <Tab label="Escolhas Inicial" {...a11yProps(1)} />
                                    </Tabs>
                                </Box>
                                <TabPanel value={value} index={0}>
                                    {showDraftCalouros ? (
                                        <>
                                            <Grid size={{ xs: 12, sm: 12 }} margin={1} spacing={1} paddingBottom={1}>
                                                {!removeLoading && <Loading />}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} margin={1} spacing={1}>
                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{UtilidadeService.isMobile() ? `PREFERÊNCIAS - FRANQUIA ${nome_Franquia.toUpperCase()}` : `PREFERÊNCIAS DE ESCOLHAS DRAFT - FRANQUIA ${nome_Franquia.toUpperCase()}`}</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 11, sm: 12 }} margin={1} spacing={1}>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 11, sm: 12 }} margin={1} paddingTop={1} spacing={1} display="flex" justifyItems="center" >
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <Autocomplete
                                                        openText="Abrir"
                                                        closeText="Fechar"
                                                        noOptionsText="Sem opções"
                                                        loadingText="Carregando..."
                                                        disablePortal
                                                        options={opcoesAutoCompleteJogadorCalouros}
                                                        loading={isLoading}
                                                        disabled={isLoading}
                                                        value={autoCompleteSelectedOptionCalouros}
                                                        size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                        onChange={(event, newValue) => { setSelectedIdCompleteCalouros(newValue?.codigo); handleCarregarDadosJogadorCalouro(newValue?.codigo) }}
                                                        popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 20 : 28} /> : undefined}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Jogador"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} paddingTop={2}>
                                                {!removeLoading && <Loading />}
                                            </Grid>
                                            {existeDadosJogadorCalouro && (
                                                <>
                                                    <Grid size={{ xs: 12, sm: 12 }} margin={1} spacing={1} paddingTop={2}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 15 : 20 }}>DADOS JOGADOR</Typography>
                                                        <hr />
                                                    </Grid>

                                                    <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" paddingTop={2} >
                                                        <Grid size={{ xs: 3, sm: 6, md: 2 }} >
                                                            <Typography> <img src={fotoJogador} alt="fotoJogador" width={UtilidadeService.isMobile() ? 90 : 180} height={UtilidadeService.isMobile() ? 75 : 150} /></Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 9, sm: 6, md: 3 }} >
                                                            <Typography padding={UtilidadeService.isMobile() ? 1 : 2} variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}><span style={{ fontWeight: "bold" }}>JOGADOR:</span> {nomeJogador}</Typography>
                                                            <Typography padding={UtilidadeService.isMobile() ? 1 : 2} variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}><span style={{ fontWeight: "bold" }}>FRANQUIA:</span> {franquiaJogador}</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 7 }} display="flex" alignItems="center" justifyContent="center" justifyItems="center" textAlign="end">
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={() => { handleAdicionarJogadorCalouro(); setExisteDadosJogadorCalouro(false); }}
                                                                startIcon={<Icon>check</Icon>}
                                                            >
                                                                Adicionar
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} margin={1} spacing={1} paddingTop={2}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 15 : 20 }}>SALÁRIOS </Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" paddingTop={2} >
                                                        <Grid size={{ xs: 4, sm: 6, md: 2 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 1</Typography>
                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario1Calouro)}</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 4, sm: 6, md: 2 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 2</Typography>
                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario2Calouro)}</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 4, sm: 6, md: 2 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 3</Typography>
                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario3Calouro)}</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 4, sm: 6, md: 2 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 4</Typography>
                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario4Calouro)}</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 4, sm: 6, md: 2 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 5</Typography>
                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario5Calouro)}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} margin={1} spacing={1}>
                                                        <Typography variant="h6">STATS</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" paddingTop={2} >
                                                        <Grid container size={{ xs: 12, sm: 6, md: 12 }} paddingBottom={UtilidadeService.isMobile() ? 0 : 1} paddingTop={UtilidadeService.isMobile() ? 0 : 1} spacing={1}>
                                                            {listaStats.length > 0 && (listaStats.map((m) => (
                                                                <Grid size={{ xs: 3, sm: 6, md: 1 }} >
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>{m.nome}</Typography>
                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14 }}>{m.peso_Padrao}</Typography>
                                                                </Grid>
                                                            )))}
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            )}
                                            {listaDataGridCalouro.length > 0 && (
                                                <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={UtilidadeService.isMobile() ? 0 : 1} spacing={2}>
                                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                                                        <Grid size={{ xs: 12, sm: 12 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}> LISTA PREFERENCIAL</Typography>
                                                            <hr />
                                                        </Grid>
                                                        <Grid container size={{ xs: 12, sm: 12 }}>
                                                            <Box sx={{
                                                                height: 'auto', width: '100%',
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white,
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                   color: themeName === "light" ? "black" : "auto",
                                                                },
                                                            }}>
                                                                <DataGrid
                                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                    getRowId={(rows) => rows.ordem}
                                                                    columnVisibilityModel={{ codigo_Jogador: false }}
                                                                    rows={listaDataGridCalouro}
                                                                    columns={columnsEscolhas}
                                                                    initialState={{
                                                                        pagination: {
                                                                            paginationModel: {
                                                                                pageSize: 15,
                                                                                page: pagina,
                                                                            },
                                                                        },
                                                                    }}
                                                                    pageSizeOptions={[15, 24, 50, 100]}
                                                                    disableRowSelectionOnClick
                                                                    disableColumnFilter
                                                                    disableColumnMenu
                                                                    sx={{
                                                                        fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                                    }}

                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </>) :
                                        (
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Draft fechado!</Typography>
                                                <hr />
                                            </Grid>
                                        )
                                    }
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    {showDraftInicial ? (
                                        <>
                                            <Grid size={{ xs: 12, sm: 12 }} margin={1} spacing={1} paddingBottom={1}>
                                                {!removeLoading && <Loading />}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} margin={1} spacing={1}>
                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{UtilidadeService.isMobile() ? `PREFERÊNCIAS - FRANQUIA ${nome_Franquia.toUpperCase()}` : `PREFERÊNCIAS DE ESCOLHAS DRAFT - FRANQUIA ${nome_Franquia.toUpperCase()}`}</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 11, sm: 12 }} margin={1} spacing={1}>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 11, sm: 12 }} margin={1} paddingTop={1} spacing={1} display="flex" justifyItems="center" >
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <Autocomplete
                                                        openText="Abrir"
                                                        closeText="Fechar"
                                                        noOptionsText="Sem opções"
                                                        loadingText="Carregando..."
                                                        disablePortal
                                                        options={opcoesAutoCompleteJogadorInicial}
                                                        loading={isLoading}
                                                        disabled={isLoading}
                                                        value={autoCompleteSelectedOptionInicial}
                                                        size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                        onChange={(event, newValue) => { setSelectedIdCompleteInicial(newValue?.codigo); handleCarregarDadosJogadorInicial(newValue?.codigo) }}
                                                        popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 20 : 28} /> : undefined}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Jogador"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} paddingTop={2}>
                                                {!removeLoading && <Loading />}
                                            </Grid>
                                            {existeDadosJogadorInicial && (
                                                <>
                                                    <Grid size={{ xs: 12, sm: 12 }} margin={1} spacing={1} paddingTop={2}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 15 : 20 }}>DADOS JOGADOR</Typography>
                                                        <hr />
                                                    </Grid>

                                                    <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" paddingTop={2} >
                                                        <Grid size={{ xs: 3, sm: 6, md: 2 }} >
                                                            <Typography> <img src={fotoJogador} alt="fotoJogador" width={UtilidadeService.isMobile() ? 90 : 180} height={UtilidadeService.isMobile() ? 75 : 150} /></Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 9, sm: 6, md: 3 }} >
                                                            <Typography padding={UtilidadeService.isMobile() ? 1 : 2} variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}><span style={{ fontWeight: "bold" }}>JOGADOR:</span> {nomeJogador}</Typography>
                                                            <Typography padding={UtilidadeService.isMobile() ? 1 : 2} variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}><span style={{ fontWeight: "bold" }}>FRANQUIA:</span> {franquiaJogador}</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 7 }} display="flex" alignItems="center" justifyContent="center" justifyItems="center" textAlign="end">
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={() => { handleAdicionarJogadorInicial(); setExisteDadosJogadorInicial(false); }}
                                                                startIcon={<Icon>check</Icon>}
                                                            >
                                                                Adicionar
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} margin={1} spacing={1} paddingTop={2}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 15 : 20 }}>SALÁRIOS </Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" paddingTop={2} >
                                                        <Grid size={{ xs: 4, sm: 6, md: 2 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 1</Typography>
                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario1)}</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 4, sm: 6, md: 2 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 2</Typography>
                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario2)}</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 4, sm: 6, md: 2 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 3</Typography>
                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario3)}</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 4, sm: 6, md: 2 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 4</Typography>
                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario4)}</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 4, sm: 6, md: 2 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 5</Typography>
                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario5)}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} margin={1} spacing={1}>
                                                        <Typography variant="h6">STATS</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" paddingTop={2} >
                                                        <Grid container size={{ xs: 12, sm: 6, md: 12 }} paddingBottom={UtilidadeService.isMobile() ? 0 : 1} paddingTop={UtilidadeService.isMobile() ? 0 : 1} spacing={1}>
                                                            {listaStats.length > 0 && (listaStats.map((m) => (
                                                                <Grid size={{ xs: 3, sm: 6, md: 1 }} >
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>{m.nome}</Typography>
                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14 }}>{m.peso_Padrao}</Typography>
                                                                </Grid>
                                                            )))}
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            )}
                                            {listaDataGridInicial.length > 0 && (
                                                <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={UtilidadeService.isMobile() ? 0 : 2} spacing={2}>
                                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                                                        <Grid size={{ xs: 12, sm: 12 }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 15 : 20 }}> LISTA PREFERENCIAL</Typography>
                                                            <hr />
                                                        </Grid>
                                                        <Grid container size={{ xs: 12, sm: 12 }}>
                                                            <Box sx={{
                                                                height: 'auto', width: '100%',
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white,
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                },
                                                            }}>
                                                                <DataGrid
                                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                    getRowId={(rows) => rows.ordem}
                                                                    rows={listaDataGridInicial}
                                                                    columnVisibilityModel={{ codigo_Jogador: false }}
                                                                    columns={columnsEscolhas}
                                                                    initialState={{
                                                                        pagination: {
                                                                            paginationModel: {
                                                                                pageSize: 15,
                                                                                page: pagina,
                                                                            },
                                                                        },
                                                                    }}
                                                                    pageSizeOptions={[15, 24, 50, 100]}
                                                                    disableRowSelectionOnClick
                                                                    disableColumnFilter
                                                                    disableColumnMenu
                                                                    sx={{
                                                                        fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                                    }}

                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </>) :
                                        (
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Draft fechado!</Typography>
                                                <hr />
                                            </Grid>
                                        )
                                    }
                                </TabPanel>
                            </Paper>
                        </Grid>

                    </Grid>
                </Box>
            </VForm>
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
        </LayoutBaseDePagina >

    );
};